export default [
  {
    path: '/empresa',
    name: 'Empresa',
    component: () => import('@/pages/empresas/Empresa'),
    children: [
      /* Empresas */
      {
        path: 'empresas',
        name: 'Empresa.Empresas',
        meta: {
          descricao: 'Empresas'
        },
        component: () => import('@/pages/empresas/Empresas')
      },

      /* Equipes */
      {
        path: 'equipes',
        name: 'Empresa.Equipes',
        meta: {
          descricao: 'Equipes'
        },
        component: () => import('@/pages/empresas/Equipe')
      },

      /* Colaboradores */
      {
        path: 'colaboradores',
        name: 'Empresa.Colaboradores',
        meta: {
          descricao: 'Colaboradores'
        },
        component: () => import('@/pages/colaboradores/Colaboradores')
      },

      /* Parametros */
      {
        path: 'parametros',
        name: 'Empresa.Parametros',
        meta: {
          descricao: 'Parametros'
        },
        component: () => import('@/pages/parametros_empresa/ParametrosEmpresa')
      }
    ]
  },
]
